export const GLOSSARY = []
